export const BACKEND = {
    SERVER: "https://thinkcat.tools:5002",
    // SERVER: "http://127.0.0.1:5000", 
};

